export const FLOODGATE_API_ROOT = 'ows/v1.0/FloodGateSurvey/';

export interface FloodgateSettingDataType {
    SettingName: string;
    ItemKey: string;
    ItemValue?: string;
}
